import {
  type MonthlyCustomerReportDailyReportListExEntity,
  apiClient
} from '@/libs/api'
import { type MonthlyCustomerReportDailyReportsRequestQuery } from '@/libs/api/types'

export type FetchMonthlyCustomerReportDailyReportsQuery = {
  tenantKey: string
  monthlyCustomerReportId: number
  query: MonthlyCustomerReportDailyReportsRequestQuery
}

export const fetchMonthlyCustomerReportDailyReports = async (
  {
    tenantKey,
    monthlyCustomerReportId,
    query
  }: FetchMonthlyCustomerReportDailyReportsQuery,
  signal?: AbortSignal
): Promise<MonthlyCustomerReportDailyReportListExEntity[]> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .monthly_customer_reports._reportId(monthlyCustomerReportId)
    .daily_reports.$get({ query, config: { signal } })
  return data
}
